import CryptoJS, { AES } from 'crypto-js';

const key = CryptoJS.enc.Utf8.parse('12345678OVERSEAS');
const iv = CryptoJS.enc.Utf8.parse('OVERSEAS12345678');

export class MyAES {
  static encrypt(data: string): string {
    let srcs = CryptoJS.enc.Utf8.parse(data);
    let encrypted = CryptoJS.AES.encrypt(srcs, key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });
    return encrypted.ciphertext.toString().toUpperCase();
  }

  /**
   * 解密，失败时返回空串
   *
   * 这些解密结果多数只用于埋点参数，且调用点散落在 login / register / invite
   * 等页面的渲染体中。CryptoJS 的 Utf8.stringify 遇到非法字节会抛
   * "Malformed UTF-8 data"，在渲染期抛出会让 React 卸载整棵组件树导致整页白屏，
   * 因此这里必须吞掉异常而不是向上抛。
   */
  static decrypt(data: string): string {
    try {
      const encryptedHexStr = CryptoJS.enc.Hex.parse(data);
      const srcs = CryptoJS.enc.Base64.stringify(encryptedHexStr);
      const decrypted = CryptoJS.AES.decrypt(srcs, key, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      });
      return decrypted.toString(CryptoJS.enc.Utf8);
    } catch {
      return '';
    }
  }
}

export function aes() {
  const secretKey = 'invitation-test';
  return {
    encrypt: (str: string) => AES.encrypt(str, secretKey).toString(),
    decrypt: (str: string) => {
      try {
        return AES.decrypt(str, secretKey).toString(CryptoJS.enc.Utf8);
      } catch {
        return '';
      }
    },
  };
}

/**
 * 安全解码 URL 参数
 *
 * decodeURIComponent 对非法百分号转义（如 "100%"、"%ZZ"）会抛 URIError，
 * 而调用点位于页面渲染体中，抛出即整页白屏。解码失败时原样返回。
 */
export function safeDecodeURIComponent(value: string | string[] | null | undefined): string {
  if (value === null || value === undefined) return '';
  const raw = Array.isArray(value) ? value[0] ?? '' : value;
  try {
    return decodeURIComponent(raw);
  } catch {
    return raw;
  }
}
